import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateFilter } from '@common/data-models/navigation/viewstate-filter';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateFilterSerializer, ViewStateOptionsSerializer } from '@common/data-models/serializers/serializers';
import { ViewStateSortOders } from '@common/enums/viewstate-sort-orders';

import { Record } from './record';
import { ViewStateRecord } from './viewstate-record';

export class SingleViewStateRecord extends ViewStateRecord {
    public isViewStateCustomCardItemsBlank: boolean = false;

    public initialize() {
        super.initialize();
        this.viewStateFilter = ViewStateFilterSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType);
        this.viewStateSorting = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateSorting);
        this.viewStateGrouping = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateGrouping);
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateGrouping(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateGrouping');
    }
    public set viewStateGrouping(value: ViewStateOptions) {
        this.set('PSTViewStateGrouping', value);
    }

    public get viewStateFilter(): ViewStateFilter {
        return this.getAs<ViewStateFilter>('PSTViewStateFilter');
    }
    public set viewStateFilter(value: ViewStateFilter) {
        this.set('PSTViewStateFilter', value);
    }

    public get viewStateSorting(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateSorting');
    }
    public set viewStateSorting(value: ViewStateOptions) {
        this.set('PSTViewStateSorting', value);
    }

    public get viewStateCustomCardItems(): Array<FieldDef> {
        return this.getAs<Array<FieldDef>>('PSTViewStateTopicCardCustomItems');
    }
    public set viewStateCustomCardItems(value: Array<FieldDef>) {
        this.set(
            'PSTViewStateTopicCardCustomItems',
            value.filter(item => item?.ID)
        );
    }

    public get viewStateSortOrder(): string {
        let _default = ViewStateSortOders.ASC;
        if (Record.globalTablesService.isDateTimeFieldType(this.viewStateSorting.Value) || this.viewStateSorting.Value === PSTFieldNames.PSTModTime) {
            _default = ViewStateSortOders.DESC;
        }
        const value = this.getAs<string>('PSTViewStateSortOrder');
        return value || _default;
    }
    public set viewStateSortOrder(value: string) {
        this.set('PSTViewStateSortOrder', value);
    }

    public get viewStateGroupSortOrder(): string {
        let _default = ViewStateSortOders.ASC;
        if (Record.globalTablesService.isDateTimeFieldType(this.viewStateGrouping.Value) || this.viewStateGrouping.Value === PSTFieldNames.PSTModTime) {
            _default = ViewStateSortOders.DESC;
        }
        const value = this.getAs<string>('PSTViewStateGroupSortOrder');
        return value || _default;
    }
    public set viewStateGroupSortOrder(value: string) {
        this.set('PSTViewStateGroupSortOrder', value);
    }

    public toggleViewStateSortOrder() {
        if (this.viewStateSortOrder === ViewStateSortOders.ASC) {
            this.viewStateSortOrder = ViewStateSortOders.DESC;
        } else {
            this.viewStateSortOrder = ViewStateSortOders.ASC;
        }
    }

    public toggleViewStateGroupSortOrder() {
        if (this.viewStateGroupSortOrder === ViewStateSortOders.ASC) {
            this.viewStateGroupSortOrder = ViewStateSortOders.DESC;
        } else {
            this.viewStateGroupSortOrder = ViewStateSortOders.ASC;
        }
    }
}
